export default class DesignUtils {

  /**
   * Returns progressColor by value
   *
   * @param value progress value to get color for
   * @param colorLow color for low value
   * @param colorMedium color for medium value
   * @param colorHigh color for high value
   * @param colorHighest color for highest value
   * @returns {string|*|string} color for progress
   */
  static getProgressColor (value, colorLow, colorMedium, colorHigh, colorHighest) {
    if (value < 25) {
      return colorLow ? colorLow : 'scaleRed';
    } else if (value >= 25 && value < 50) {
      return colorMedium ? colorMedium : 'scaleOrange';
    } else if (value >= 50 && value < 75) {
      return colorHigh ? colorHigh : 'scaleYellow';
    } else if (value >= 75) {
      return colorHighest ? colorHighest : 'scaleGreen';
    } else {
      return 'scaleDefault'
    }
  }
}